import React from "react";
import ContentLoader from "react-content-loader";

const ServiceCardPlaceholder = () => {
  return (
    <div className="col-lg-2 col-md-2 col-sm-6 col-xs-6">
      <ContentLoader viewBox="0 0 500 700" className="mb-3">
        <rect x="0" y="0" rx="0" ry="0" width="100%" height="700" />
      </ContentLoader>
    </div>
  );
};

export default ServiceCardPlaceholder;
